
import axios from 'axios'
export default {
  name: 'CourseInfo',
  props: {
    city: { type: String, default: '' },
    nearby: { type: String, default: 'auto' }
  },
  data() {
    return {
      classrooms: [],
      ready: false
    }
  },
  computed: {
    cityName() {
      const page = this.$store.state.pages.page || {}
      return page.geolocationCity || page.slug || ''
    },
    hasClassrooms() {
      return this.classrooms && this.classrooms.length > 0
    }
  },
  // Client-side fetch (the original approach). Runs in the browser where region/
  // label resolve properly. Not SSR'd — the classroom table and its schema render
  // after hydration, as they did before.
  async mounted() {
    const page = this.$store.state.pages.page || {}
    const city = page.geolocationCity || page.slug || ''
    if (city) {
      const label = this.$store.getters['cart/getPriceLabel'] || 'TEFLORG'
      try {
        const res = await axios.get(
          process.env.DATA_URL + '/classroom/city/' + city + '?productPriceLabel=' + label
        )
        this.classrooms = res.data || []
      } catch (e) {
        this.classrooms = []
      }
    }
    this.ready = true
  }
}
